import DateHandler from "@/composables/handlers/DateHandler";

class StorageItem {
    /**
     * @param {string} key 
     * @param {any} value 
     * @param {number} ttl - Tempo de vida em segundos (ex: 3600 para 1 hora)
     */
    constructor(key = null, value = null, ttl = null) {
        this.key = key;
        this.value = value;
        this.ttl = ttl || process.env.STORAGE_ITEM_LIFETIME;
        this.created_at = DateHandler.now();
    }

    /**
     * Gets value if is not expired
     * @returns {any|Array}
     */
    getValue() {
        if (this.isExpired()) {
            return [];
        }
        return this.value;
    }

    /**
     * Checks if value is valid
     * @returns {boolean}
     */
    isExpired() {
        if (!this.created_at) return true;

        const now = DateHandler.now();
        const diff = now.diff(this.created_at, 'seconds').toObject();

        return diff.seconds >= this.ttl;
    }
}

export default StorageItem;